<button
  type="button"
  class="info-tip-trigger"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-expanded]="open()"
  (mouseenter)="show()"
  (mouseleave)="hide()"
  (focus)="show()"
  (blur)="hide()"
>
  <mat-icon aria-hidden="true">info</mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayPositions]="positions()"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayPanelClass]="'app-info-tip-panel'"
  [cdkConnectedOverlayViewportMargin]="12"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayFlexibleDimensions]="false"
>
  <div class="info-tip-bubble" role="tooltip" (mouseenter)="show()" (mouseleave)="hide()">
    {{ text() }}
  </div>
</ng-template>
